module.exports = __webpack_public_path__ + "img/01_2.bb5f557d.png";